import { render, staticRenderFns } from "./CAAG1130.vue?vue&type=template&id=3a3d7b57&scoped=true"
import script from "./CAAG1130Controller.ts?vue&type=script&lang=ts&external"
export * from "./CAAG1130Controller.ts?vue&type=script&lang=ts&external"
import style0 from "./CAAG1130.vue?vue&type=style&index=0&id=3a3d7b57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3d7b57",
  null
  
)

export default component.exports